import { parse } from 'papaparse';

const number = value =>
  Number(
    value
      .replace('(', '')
      .replace(')', '')
      .trim(),
  ) || null;

const attempt = ($number, weight, sequenceNumber) => ({
  number: $number,
  weight: Math.abs(number(weight)),
  isGoodLift: number(weight) > 0,
  sequenceNumber: number(sequenceNumber),
});

const result = value => number(value);
const rank = value => number(value);

// FIXME: Read from csv file?
const SNATCH = '4ff4b822-5da9-48e1-9c84-bcd48ffb3372';
const CLEAN_AND_JERK = '3df9eef1-669b-40c4-9c0f-a053673071a9';

const mapCsvRow = row => {
  const column = key =>
    Object.entries(row)
      .find(([_]) => _.trim() === key)[1]
      .trim();

  return {
    groupLetter: column('G'),
    lotNumber: number(column('Lot')),
    startNumber: number(column('#')),
    name: column('N'),
    lifts: {
      [SNATCH]: {
        attempts: [
          attempt(1, column('S1'), column('S1#')),
          attempt(2, column('S2'), column('S2#')),
          attempt(3, column('S3'), column('S3#')),
        ],
        result: result(column('S=')),
        rank: rank(column('SR')),
      },
      [CLEAN_AND_JERK]: {
        attempts: [
          attempt(1, column('C1'), column('C1#')),
          attempt(2, column('C2'), column('C2#')),
          attempt(3, column('C3'), column('C3#')),
        ],
        result: result(column('C=')),
        rank: result(column('CR')),
      },
    },
    total: {
      result: result(column('T=')),
      rank: result(column('TR')),
    },
  };
};

const parseTcrr = csvString => {
  const options = {
    header: true,
    skipEmptyLines: true,
  };

  const { data } = parse(csvString, options);

  return data.map(mapCsvRow);
};

export default parseTcrr;



// WEBPACK FOOTER //
// ./src/demo/parseTcrr.js